import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
} from '@chakra-ui/react';
import { FaGavel } from 'react-icons/fa';
import SEO from '../components/SEO';
import ScrollIndicator from '../components/ScrollIndicator';

const Terms = () => {
  return (
    <>
      <Box minH="100vh" pt={{ base: 20, md: 20 }} pb={{ base: 12, md: 20 }} id="terms-container">
        <SEO
          title="Terms of Use - Namaskar India"
          description="Terms of use for Namaskar India podcast."
          noindex={true}
        />

        <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
          <VStack spacing={{ base: 8, sm: 10, md: 12 }} align="stretch">
            {/* Header */}
            <VStack spacing={{ base: 3, sm: 4 }} maxW="3xl" mx="auto" textAlign="center">
              <Heading
                as="h1"
                fontSize={{ base: "3xl", sm: "4xl", md: "6xl", lg: "7xl" }}
                lineHeight="1.2"
                variant="gradient"
              >
                Terms of Use
              </Heading>
            </VStack>

            {/* Content */}
            <Box
              maxW="2xl"
              mx="auto"
              w="full"
              background="rgba(255,150,50,0.04)"
              backdropFilter="blur(12px)"
              borderRadius="2xl"
              border="1px solid rgba(255,150,50,0.08)"
              p={{ base: 6, md: 10 }}
              position="relative"
              overflow="hidden"
            >
              <Box position="absolute" top={0} left={0} right={0} h="2px" bgGradient="linear(to-r, transparent, terracotta.500, transparent)" />
            <VStack spacing={{ base: 6, sm: 7, md: 8 }} align="stretch">
              <Text 
                color="whiteAlpha.900" 
                fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                lineHeight="tall"
              >
                By accessing and using Namaskar India podcast content and website, you agree to these terms of use. Please read them carefully.
              </Text>

              <List spacing={{ base: 4, sm: 5, md: 6 }}>
                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaGavel} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text 
                    color="whiteAlpha.900" 
                    fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                    lineHeight="tall"
                  >
                    Our content is for personal, non-commercial use only. You may not redistribute, sell, or use our content for commercial purposes without explicit written permission.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaGavel} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text 
                    color="whiteAlpha.900" 
                    fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                    lineHeight="tall"
                  >
                    All podcast content is protected by copyright. You may share links to episodes and quote brief excerpts with proper attribution to Namaskar India.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaGavel} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text 
                    color="whiteAlpha.900" 
                    fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                    lineHeight="tall"
                  >
                    While we strive for accuracy in our historical storytelling, we make no guarantees about the completeness or accuracy of the information presented. Historical interpretations may vary.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaGavel} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text 
                    color="whiteAlpha.900" 
                    fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                    lineHeight="tall"
                  >
                    We reserve the right to modify these terms at any time. Your continued use of our content constitutes acceptance of any changes.
                  </Text>
                </ListItem>
              </List>

              <Text color="whiteAlpha.500" fontSize="sm" textAlign="center" mt={4}>
                Last updated: March 2026
              </Text>
            </VStack>
            </Box>
          </VStack>
        </Container>
        <ScrollIndicator containerId="terms-container" />
      </Box>
    </>
  );
};

export default Terms;
